import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import React from "react";
import { useLocalStorage } from "usehooks-ts";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from "@/components/atomic/Dialog";
import { cn } from "@/lib/utils";

interface ModalProps {
  className?: string;
  title?: string;
  description?: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const Modal: React.FC<ModalProps> = ({
  className = "",
  title,
  description,
  children,
  footer,
  open,
  onOpenChange,
}) => {
  const [isSideBarOpen] = useLocalStorage("isSideBarOpen", true);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogOverlay
        className={cn(
          "fixed top-[100px]",
          isSideBarOpen ? "left-[260px]" : "left-[60px]",
        )}
      />
      <DialogContent
        className={cn(
          "fixed top-[130px] translate-0 max-h-[calc(100vh-240px)] max-w-[1320px] overflow-y-auto",
          isSideBarOpen ? "left-[290px] w-[calc(100vw-240px)]" : "left-[90px] w-[calc(100vw-120px)]",
          className,
        )}
      >
        <VisuallyHidden>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
        </VisuallyHidden>
        <div>{children}</div>
        {footer && <DialogFooter>{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
